import { render } from "./CustomerOverview.vue?vue&type=template&id=60a2735c&scoped=true"
import script from "./CustomerOverview.vue?vue&type=script&lang=js"
export * from "./CustomerOverview.vue?vue&type=script&lang=js"

import "./CustomerOverview.vue?vue&type=style&index=0&id=60a2735c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a2735c"]])

export default __exports__